import React, { useEffect } from 'react';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserPerRole } from '../../../redux/slice/getUserPerRoleSlice';
import permissionIcon from "../../../assets/img/permission-icon.png";
import userIcon from "../../../assets/img/user-icon.png";
import { useHasPermission } from '../../../hooks/useHasPermission';
import { fetchPermissionsById } from '../../../redux/slice/getPermissionListByIdSlice';

export default function ViewUsers() {
     const dispatch = useDispatch();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const canViewRole = useHasPermission("Role-view");
    const canViewPerm = useHasPermission("Permission-view");
    const canViewAssignPerm = useHasPermission("Assign/Remove Permission-view");

    const { usersPerRole, status } = useSelector(state => state.userPerRole);
    const userList = usersPerRole[0]?.users;
    const roleId = queryParams.get("roleId");
    const permId = queryParams.get("permId");
    const isRolePage = location.pathname.includes("/role/");
    const isPermissionPage = location.pathname.includes("/permission/");

    useEffect(() => {
        if (isRolePage && roleId && canViewRole) {
            dispatch(fetchUserPerRole(roleId));
        } else if (isPermissionPage && permId && canViewPerm) {
            dispatch(fetchPermissionsById(permId));
        }
    }, [dispatch, canViewRole, canViewPerm, isRolePage, isPermissionPage, roleId, permId]);

    if (!canViewRole && !canViewPerm) {
        return <p className='perm-msg'>{"You don’t have permission to view users list!"}</p>;
    }

    const handleViewPermission = async (userId, userName) => {
        if (!canViewAssignPerm) {
            toast.error("You don't have permission to view permissions of the user", { className: 'toast-error-custom', autoClose: 5000 });
            return;
        }
        navigate(`/admin/role/view-users/${userId}`, { state: { userId, userName } });
    }

    return (
        <div className='container-fluid'>
            <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: '18px' }}>
                <div className="icons-list">
                    <Breadcrumb />
                </div>
            </div>
            {/* role along with users list table */}
            <div className='section-body'>
                <div className='container-fluid'>
                    <div className='tab-content'>
                        <div className='tab-pane fade active show' id="Employee-list" role='tabpanel'>
                            <div className='card'>
                                <div className="card-header">
                                    <div className="card-body">
                                        <div className="row clearfix">
                                            <div className="role-data table-responsive">
                                                {status === 'loading' && (
                                                    <p className="loading">Loading...</p>
                                                )}

                                                {status === 'Failed' && (
                                                    <p className="server-error-msg">Server Error...</p>
                                                )}
                                                {status == 'succeeded' && (userList.length > 0 ? (
                                                    <> <h6 className='view-role'>
                                                        {isRolePage && usersPerRole[0]?.roleName
                                                            ? `Role: ${usersPerRole[0].roleName}`
                                                                : ''}
                                                    </h6>
                                                        <table className="role-data-table table table-hover table-vcenter text-nowrap mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>Name</th>
                                                                    <th>Email ID</th>
                                                                    <th>Permissions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {userList.map((list, index) => (
                                                                    <tr key={list.roleId}>
                                                                        <td className="roleIcon"><img src={userIcon} alt="role icon" /></td>                                                        <td role="gridcell"
                                                                        onClick={
                                                                                    canViewAssignPerm
                                                                                        ? () => handleViewPermission(
                                                                                            list.userId,
                                                                                            list.fullName
                                                                                        )
                                                                                        : undefined
                                                                                } style={{ cursor: canViewAssignPerm ? 'pointer' : 'default' }}>{list.fullName}</td>
                                                                        <td>{list.email}</td>
                                                                        <td className="action-column">
                                                                            <button className="delete-role" type='button'
                                                                                title={
                                                                                    canViewAssignPerm
                                                                                        ? "view"
                                                                                        : "No permission to view their permissions"
                                                                                }
                                                                                disabled={!canViewAssignPerm}
                                                                                onClick={
                                                                                    canViewAssignPerm
                                                                                        ? () => handleViewPermission(
                                                                                            list.userId,
                                                                                            list.fullName
                                                                                        )
                                                                                        : undefined
                                                                                }
                                                                            >
                                                                                <img src={permissionIcon} alt="view" style={{
                                                                                    opacity: canViewAssignPerm ? 1 : 0.5
                                                                                }} />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ) : (
                                                    <div className="no-records-found text-center">
                                                        <p>No user found for this role</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
